import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {


  public show: boolean = true;

  constructor() { }


  open() {
    this.show = true;
  }


  close() {
    this.show = false;
  }


}
